import React, {
  useState, useRef, useEffect,
} from "react";
import { PanelWrapper } from "../../PanelWrapper";
import { CalculatorTypes } from "../CalculatorPanels/calculatorTypes";
import { DepositCalculator } from "./DepositCalculator";
import { AffordabilityCalculator } from "./AffordabilityCalculator";
import { RemortgageCalculator } from "./RemortgageCalculator";
import { CalculatorControlPanel } from "./ControlPanel";
import { CalculatorStoreProvider } from "./store";
import { useIsMobile } from "../../../hooks/useIsMobile";
import { StampDutyCalculator } from "./StampDutyCalculator";
import { LoanToValueCalculatorPanel } from "./LoanToValueCalculator";

import "./styles.scss";

interface ICalculatorPanelV2Props {
  defaultTab: number;
  multipleTabs: CalculatorTypes[];
  mortgageRateBasedOnLtv?: { defaultValue: number, rates: { ltv: number, mortgageRate: number }[]};
}

export const CalculatorPanelV2: React.FunctionComponent<ICalculatorPanelV2Props> = ({
  defaultTab,
  multipleTabs,
  mortgageRateBasedOnLtv,
}) => {
  const isMobile = useIsMobile(960);
  const [activeTabName, setActiveTabName] = useState<CalculatorTypes>(CalculatorTypes.DEPOSIT);
  const [contentHeight, setContentHeight] = useState(0);
  const contentRef = useRef<HTMLDivElement>(null);

  const mappedMultipleTabs = multipleTabs.map((item, idx) => (
    { id: idx + 1, name: item }
  ));
  const updateContentHeight = () => {
    if (contentRef.current) {
      setContentHeight(contentRef.current.clientHeight);
    }
  };

  useEffect(() => {
    const defaultActiveTab = mappedMultipleTabs.find((tab) => tab.id === defaultTab)?.name;
    setActiveTabName(defaultActiveTab!);
  }, []);

  useEffect(() => {
    updateContentHeight();
  }, [activeTabName]);

  let Calculator;
  switch (activeTabName) {
    case CalculatorTypes.AFFORDABILITY: {
      Calculator = <AffordabilityCalculator />;
      break;
    }
    case CalculatorTypes.REMORTGAGE: {
      Calculator = <RemortgageCalculator mortgageRateBasedOnLtv={mortgageRateBasedOnLtv} />;
      break;
    }
    case CalculatorTypes.STAMP_DUTY: {
      Calculator = <StampDutyCalculator />;
      break;
    }
    case CalculatorTypes.LTV: {
      Calculator = <LoanToValueCalculatorPanel />;
      break;
    }
    case CalculatorTypes.DEPOSIT:
    default: {
      Calculator = <DepositCalculator />;
      break;
    }
  }

  return (
    <PanelWrapper isBetterV2>
      <CalculatorStoreProvider>
        <CalculatorControlPanel multipleTabs={mappedMultipleTabs} defaultTab={defaultTab} onChangeActiveTab={setActiveTabName} />
        <div className="tab-animation" style={!isMobile ? { height: `${contentHeight}px` } : undefined}>
          <div className="calculator-panel-v2-wrapper" ref={contentRef}>{Calculator}</div>
        </div>
      </CalculatorStoreProvider>
    </PanelWrapper>
  );
};
